


$(document).ready(function() {
    // Initially open the first FAQ and add the active class
    $('.faq-box:first-child .faq-description').slideDown();
    $('.faq-box:first-child').addClass('active');

    // FAQ click functionality
    $('.faq-titlebox').click(function() {
        // Check if the clicked FAQ is already active
        if (!$(this).parent().hasClass('active')) {
            // Close all open FAQs
            $('.faq-box .faq-description').slideUp();
            $('.faq-box').removeClass('active');
            
            // Open the clicked FAQ and add active class
            $(this).next('.faq-description').slideDown();
            $(this).parent().addClass('active');
        } else {
            // Close the current FAQ if it's already open
            $(this).next('.faq-description').slideUp();
            $(this).parent().removeClass('active');
        }
    });


    // Hide empty h3 and p tags inside .faq-box
    //$('#shopify-section-template--23500616565103__giveaway_XgXbJf .faq-box h3:empty').parent().parent().hide();  // Hides the whole faq-box if h3 inside it is empty
    //$('#shopify-section-template--23500616565103__giveaway_XgXbJf .faq-box p:empty').parent().parent().hide();   // Hides the whole faq-box if p inside it is empty

});



// get current path
var currentURL = window.location.pathname.split('/');
// get product slug siteURL/category/productSlug
var productSlug = currentURL[2];
// add class using productSlug
$('body').addClass(productSlug);
// or add id using productSlug
$('body').attr('id',productSlug);